module.exports = __webpack_public_path__ + "img/partner1.85ab577e.png";